import { useTranslation } from 'react-i18next';
import { PlusIcon, MaterialIcon, LaptopIcon, VehicleMaterialIcon } from '@schuettflix/icons-react';
import { PRODUCT_NAME_LABEL } from '@/phrase/ProductNameLabels.ts';
import { PRODUCT_TYPES } from '@schuettflix/interfaces';
import { getProductCategoryByProductType } from '@schuettflix/product-group-utils';
import {
    Button,
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuIcon,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@schuettflix/planum-react';

type AddCustomProductButtonProps = {
    supportedProducts: PRODUCT_TYPES[];
    onAddProduct?: (productType: PRODUCT_TYPES) => void;
};

export const AddCustomProductButton = ({ supportedProducts, onAddProduct }: AddCustomProductButtonProps) => {
    const { t } = useTranslation();

    return (
        <div>
            <DropdownMenu>
                <DropdownMenuTrigger asChild data-test="add-custom-product-button">
                    <Button size="md" variant="tertiary">
                        <PlusIcon size="xs" />
                        {t('product.addPosition.btn')}
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="start" onCloseAutoFocus={e => e.preventDefault()}>
                    {supportedProducts.map(productType => (
                        <DropdownMenuItem
                            key={productType}
                            inset
                            data-test={`add-product-${productType}`}
                            onClick={() => onAddProduct?.(productType)}
                        >
                            <span className="font-copy-md">{t(PRODUCT_NAME_LABEL[productType])}</span>
                            <DropdownMenuIcon>
                                <AddCustomProductButtonIcon productType={productType} />
                            </DropdownMenuIcon>
                        </DropdownMenuItem>
                    ))}
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
};

const AddCustomProductButtonIcon = ({ productType }: { productType: PRODUCT_TYPES }) => {
    const productCategory = getProductCategoryByProductType(productType);

    switch (productCategory) {
        case 'MATERIAL':
            return <MaterialIcon />;
        case 'TRANSPORT':
            return <VehicleMaterialIcon />;
        case 'MATERIAL_SERVICE':
        case 'TRANSPORT_SERVICE':
            return <LaptopIcon />;
    }
};
